import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import MDBox from "../../../../materialDashboard/components/MDBox";
import StationsTable from "../Tables/StationsTable";
import Models1Table from "../Tables/Models1Table";
import Models23Table from "../Tables/Models23Table";
import IncidentsTable from "../Tables/IncidentsTable";
import {useTranslation} from "react-i18next";

const TablesPanel = ({webgis, activeTableId, onTableChange}) => {
    const {t} = useTranslation(["webgis"]);
    const {layersState} = webgis;
    const {layers} = layersState;

    const activeLayers = [
        {id: 'stationTable', layerId: 'stations', active: layers.stations.active, component: StationsTable, label: t("layers.stations")},
        {id: 'model1Table', layerId: 'model1Stations', active: layers.model1Stations.active, component: Models1Table, label: t("layers.model1Stations")},
        {id: 'model23Table', layerId: 'models23', active: layers.models23.active, component: Models23Table, label: t("layers.models23")},
        {id: 'incidentTable', layerId: 'incidents', active: layers.incidents.active, component: IncidentsTable, label: t("layers.incidents")},
    ].filter(l => l.active);

    const activeTabIndex = activeLayers.findIndex(l => l.id === activeTableId);
    const activeTab = activeTabIndex >= 0 ? activeTabIndex : 0;

    const handleTabChange = (event, newValue) => {
        const selectedLayer = activeLayers[newValue];
        if (selectedLayer && onTableChange) {
            onTableChange(selectedLayer.id);
        }
    }

    const ActiveTable = activeLayers[activeTab]?.component;

    return (
        <MDBox>
            <MDBox>
                <Tabs value={activeTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
                    {activeLayers.map((layer) => (
                        <Tab key={layer.id} label={layer.label} />
                    ))}
                </Tabs>
            </MDBox>
            <MDBox pt={2}>
                {ActiveTable && <ActiveTable layers={layers} featuresState={webgis.featuresState} />}
            </MDBox>
        </MDBox>
    );
};

export default TablesPanel;
